<div class="checklist-table-container">
  <mat-table #table [dataSource]="dataSource">
    <!-- define column for checkbox if table is a checklist -->

    <ng-container [matColumnDef]="CHECKBOX_COLUMN">
      <mat-header-cell class="checkbox-column" *matHeaderCellDef></mat-header-cell>
      <mat-cell class="checkbox-column" *matCellDef="let rowItem">
        <checkbox [ngModel]="rowItem.checked" [disabled]="rowItem.disabled"></checkbox>
      </mat-cell>
    </ng-container>

    <!-- define table columns for each column definition specified -->
    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column.fieldName">
        <mat-header-cell
          [ngClass]="column.size && 'checklist-cell-size-' + column.size"
          *matHeaderCellDef
          >{{ column.title | translate }}</mat-header-cell
          >
          <mat-cell
            *matCellDef="let rowItem"
            [ngClass]="column.size && 'checklist-cell-size-' + column.size"
            >
            <!-- use the template for this specific column specified by the parent component as content children -->
            <div class="checklist-table-cell-container">
              @if (columnDefsMap[column.fieldName]; as columnDef) {
                <ng-container
                *ngTemplateOutlet="
                  columnDefsMap[column.fieldName];
                  context: { $implicit: rowItem.data }
                "
                ></ng-container>
              } @else {
                {{ rowItem.data[column.fieldName] }}
              }
            </div>
          </mat-cell>
        </ng-container>
      }

      <!-- define column for remove button  -->
      <ng-container [matColumnDef]="REMOVE_BUTTON_COLUMN">
        <mat-header-cell class="remove-button-column" *matHeaderCellDef></mat-header-cell>
        <mat-cell class="remove-button-column" *matCellDef="let rowItem">
          @if (rowItem.removable) {
            <button class="remove-button" (click)="removeRow(rowItem)">
              <tds-icon [name]="'cross'" size="18px"></tds-icon>
            </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let checklistTableRow; columns: displayedColumns"
        (click)="!checklistTableRow.disabled && toggleRow(checklistTableRow)"
        [class.checkable]="isChecklist"
        [class.disabled]="checklistTableRow.disabled"
        [class.removable]="checklistTableRow.removable"
      ></mat-row>
      <div class="checklist-table-no-data" *matNoDataRow>
        {{ 'DetFinnsIngaTillgängligaData' | translate }}
      </div>
    </mat-table>
  </div>
